import styled from 'styled-components';

export const EpisodesContainer = styled.div`
  margin-bottom: 10rem;
  @media screen and (max-width: 800px) {
    margin-bottom: 5rem;
  }
`;
